import { useState } from 'react';
import { useQuery } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SelectionPanel from 'automation-ui-canvas/create/SelectionPanel';
import { SEARCH_ILS_LIST_BY_TYPE } from 'automation-ui-enrollment/queries/ILSListQueries';
import { useGetHasListsToolAccess } from 'automation-ui-enrollment/hooks/useHasListsToolAccess';
import useWorkflowTypePQLs from 'automation-ui-enrollment/components/workflowType/hooks/useWorkflowTypePQLs';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ListSelectionPanel({
  setObjectTypeId,
  onClose,
  stagedTriggerOption,
  onSelectTriggerOption
}) {
  var _data$searchIlsListBy;
  const [searchTerm, setSearchTerm] = useState('');
  const hasListsToolAccess = useGetHasListsToolAccess();
  const {
    loading: pqlsLoading,
    isLocked,
    shouldSelectObjectType,
    CustomModal,
    onCloseCustomModal
  } = useWorkflowTypePQLs({
    objectTypeFilter: hasListsToolAccess
  });
  const {
    data,
    loading
  } = useQuery(SEARCH_ILS_LIST_BY_TYPE, {
    variables: {
      query: searchTerm
    }
  });
  const options = ((_data$searchIlsListBy = data === null || data === void 0 ? void 0 : data.searchIlsListByType.results) !== null && _data$searchIlsListBy !== void 0 ? _data$searchIlsListBy : []).map(({
    properties: {
      hs_list_name: {
        value: text
      },
      hs_list_id: {
        value
      },
      hs_object_type_id: {
        value: objectTypeId
      }
    }
  }) => ({
    text,
    value,
    objectTypeId,
    locked: isLocked(objectTypeId)
  }));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [CustomModal && /*#__PURE__*/_jsx(CustomModal, {
      onClose: onCloseCustomModal
    }), /*#__PURE__*/_jsx(SelectionPanel, {
      heading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createWorkflow.listSelectionPanel.title"
      }),
      options: pqlsLoading ? [] : options,
      loading: loading || pqlsLoading,
      searchTerm: searchTerm,
      onSearchTermChange: setSearchTerm,
      onClose: onClose,
      onSelectOption: ({
        value,
        objectTypeId
      }) => {
        if (shouldSelectObjectType(objectTypeId)) {
          var _stagedTriggerOption$;
          onSelectTriggerOption(Object.assign({}, stagedTriggerOption, {
            filters: [Object.assign({
              filterType: 'IN_LIST',
              operator: 'IN_LIST'
            }, stagedTriggerOption === null || stagedTriggerOption === void 0 || (_stagedTriggerOption$ = stagedTriggerOption.filters) === null || _stagedTriggerOption$ === void 0 ? void 0 : _stagedTriggerOption$[0], {
              listId: Number(value)
            })]
          }));
          setObjectTypeId(objectTypeId);
        }
      }
    })]
  });
}